<script setup lang="ts"></script>

<template>
  <div class="flex h-full">
    <Sidebar />
    <div class="flex-1 overflow-auto">
      <slot />
    </div>
  </div>
</template>
